import * as React from 'react';

export type SVGCaptchaProp = {
  onClick: () => void;
  svg: string;
};

export const SVGCaptcha: React.FunctionComponent<SVGCaptchaProp> = props => {
  const { onClick, svg } = props;
  return (
    <div
      className={`cursor-pointer`}
      onClick={onClick}
      dangerouslySetInnerHTML={{
        __html: svg,
      }}
    />
  );
};
